<template>
  <!-- 附加材料下载列表 -->
  <div v-if="hasMaterials" class="materials-section">
    <div class="materials-section-1">
 <h3 class="section-title flex align-cen">
    <div class="tit">学习资料</div>
    <div class="allupload mft download-link" @click="downloadAll" v-if="materialList.length > 1">
        全部下载
    </div>
 </h3>
    <ul class="materials-list">
      <li 
        v-for="(material, index) in materialList" 
        :key="index" 
        class="material-item"
      >
        <div class="material-info flex align-cen">
          <span class="material-name">{{ getFileName(material) }}</span>
          <span class="material-format">{{ getFileExtension(material).toUpperCase() }}</span>
        </div>
        <div class="actions">
        <a :href="material" target="_blank" class="view-btn" v-if="isViewableFile(material)">查看</a>
        <a :href="material" class="download-btn" :download="getFileName(material)">下载</a>
      </div>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaterialsDownload',
  props: {
    materials: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
        isDownloadingAll:false,
    }
  },
  computed: {
    // 将逗号分隔的字符串转为数组
    materialList() {
      if (!this.materials) return []
      return this.materials
        .split(',')
        .map(url => url.trim())
        .filter(url => url.length > 0)
    },
    hasMaterials() {
      return this.materialList.length > 0
    }
  },
  methods: {
    // 从URL提取文件名
    getFileName(url) {
      const fileName = url.split('/').pop() || '未命名文件'
      return fileName.split('?')[0]
    },
    // 获取文件扩展名
    getFileExtension(url) {
      const fileName = this.getFileName(url)
      const parts = fileName.split('.')
      return parts.length > 1 ? parts.pop() : ''
    },
      isViewableFile(url) {
      const ext = this.getFileExtension(url)
      return ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'txt'].includes(ext)
    },
        downloadAll() {
      this.materialList.forEach((url, index) => {
        setTimeout(() => {
          const link = document.createElement('a')
          link.href = url
          link.download = this.getFileName(url)
          link.target = '_blank' // 防止在同一个标签页打开PDF
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }, index * 300)
      })
    }
  }
}
</script>

<style scoped>
.material-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.material-format {
  padding: 2px 8px;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
  margin-left: 10px;
}
.download-link {
  padding: 6px 12px;
  background: #1890ff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.3s;
  cursor: pointer;
}

.download-link:hover {
  background: #40a9ff;
}
.materials-section {
  margin-top: 20px;
  padding: 15px;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}

.section-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.download-all-btn {
  padding: 6px 12px;
  background: #52c41a;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.download-tips {
  font-size: 12px;
  color: #fa8c16;
  background: #fff7e6;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 12px;
  border: 1px solid #ffd591;
}

.material-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 8px;
  background: white;
  border-radius: 6px;
  border: 1px solid #eee;
}

.material-item:last-child {
  margin-bottom: 0;
}

.file-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-type {
  padding: 2px 8px;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.actions {
  display: flex;
  gap: 8px;
}

.view-btn,
.download-btn {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  text-decoration: none;
  white-space: nowrap;
}

.view-btn {
  background: #fff;
  color: #1890ff;
  border: 1px solid #1890ff;
}

.download-btn {
  background: #1890ff;
  color: white;
  border: 1px solid #1890ff;
}

.view-btn:hover {
  background: #e6f7ff;
}

.download-btn:hover {
  background: #40a9ff;
}
@media (max-width: 640px){
  .material-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
  display: block;
}
}
</style>